import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import {
  DisableProgramCatalogCategory,
  DISABLEProgramCatalogCategory,
} from '../requests'

type CategoryData = unknown // The return type of your mutation
type CategoryError = unknown // The error type
type CategoryVariables = unknown // The variables type
type Options = Omit<
  UseMutationOptions<CategoryData, CategoryError, CategoryVariables>,
  'mutationFn'
>

export const useDisableProgramCatalogCategory = (options: Options) => {
  return useMutation({
    mutationFn: async (payload: DisableProgramCatalogCategory) => {
      return DISABLEProgramCatalogCategory(payload)
    },
    mutationKey: [],
    ...options,
  })
}
